module.exports = __webpack_public_path__ + "media/Video 87.d142a3d0.mp4";